import { events } from '@estee/elc-service-bus';
import { Event } from '~entities/Event';
import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';

export class AppointmentCallStoreClickedUseCase {
    private storeName: string;
    private eventRepository: EventRepository;

    constructor(storeName: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.storeName = storeName;
    }

    public async execute() {
        const payload = {
            event_name: 'appointment booking',
            event_category: 'appointment booking',
            event_action: 'tout to call store',
            event_label: this.storeName
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_CALL_STORE_CLICKED,
            type: 'link',
            payload
        });

        this.eventRepository.addEventToQueue(newEvent);
    }
}
